module.exports = __webpack_public_path__ + "img/works1.50aefb4c.jpg";